export default __webpack_public_path__ + "static/media/debit.000bf640.png";